import { render, staticRenderFns } from "./ResultsListMain.vue?vue&type=template&id=44dfe5bf&"
import script from "./ResultsListMain.vue?vue&type=script&lang=js&"
export * from "./ResultsListMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports